import {
  ObjectProperty,
  Statement,
  ExpressionStatement,
  AssignmentExpression,
  Expression,
  Identifier,
} from '@babel/types';
import { BaseFunctionExpression } from './javascript';
import { ErrorDescriptor } from './result';
import { PropertiesValidator } from './properties-base.validator';

const expressionFilter = (x: Statement): x is ExpressionStatement =>
  x.type === 'ExpressionStatement';

const mapExpression = (x: ExpressionStatement): Expression => x.expression;

const assignmentFilter = (x: Expression): x is AssignmentExpression =>
  x.type === 'AssignmentExpression';

export class PropertiesReassignmentValidator implements PropertiesValidator {
  validate(property: ObjectProperty): ErrorDescriptor[] {
    const propertiesFunction = property.value as BaseFunctionExpression;
    if (propertiesFunction.body.type === 'BlockStatement') {
      const reassignments = propertiesFunction.body.body
        .filter(expressionFilter)
        .map(mapExpression)
        .filter(assignmentFilter)
        .filter(
          (b) =>
            (b.left as Identifier).name ===
            (propertiesFunction.params[0] as Identifier).name,
        );
      if (reassignments.length) {
        return reassignments.map((reassignment) => ({
          description: 'Do not reassign source entity input param',
          location: reassignment.loc,
        }));
      }
    }

    return [];
  }
}
